import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getSupporterDataIssues, useSupporterDataStatus } from '@sola/supporter-sdk/hooks/data-status.ts';
import { SupporterQueryPart } from '@sola/supporter-sdk/queries.ts';
import { createPartialDataAlert, createPartialDataAlertMulti } from '../../utils/alerts.tsx';
import { LocalAlert } from '../local-alerts/local-alerts.tsx';
export const PrimerError: React.FC<{
  keysToAlert?: SupporterQueryPart[];
}> = t0 => {
  const $ = _c(5);
  const {
    keysToAlert
  } = t0;
  const {
    data: dataStatus
  } = useSupporterDataStatus();
  let t1;
  if ($[0] !== dataStatus || $[1] !== keysToAlert) {
    bb0: {
      const issues = getSupporterDataIssues(dataStatus, keysToAlert);
      if (issues.length === 0) {
        t1 = null;
        break bb0;
      }
      t1 = issues.length === 1 ? createPartialDataAlert(issues[0].key) : createPartialDataAlertMulti();
    }
    $[0] = dataStatus;
    $[1] = keysToAlert;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dataAlert = t1;
  if (!dataAlert) {
    return null;
  }
  let t2;
  if ($[3] !== dataAlert) {
    t2 = <LocalAlert alert={{
      id: "dataAlert",
      ...dataAlert
    }} scrollIntoView={false} />;
    $[3] = dataAlert;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};